export const cilParagraph = ["24 24","<path d='M20.625 3h-10.875c-3.314 0-6 2.686-6 6s2.686 6 6 6v0h2.625v6h5.25v-16.5h3zM9.75 13.5c-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5v0h2.625v9zM16.125 19.5h-2.25v-15h2.25z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-paragraph.js
// module id = null
// module chunks = 